<template>
  <div class="filters">
    <div class="filters-wrapper">
      <div class="filter-box">
        <p class="filter-box-title">Région</p>
        <div class="filter-box-content">
          <select
            class="select"
            :class="{ empty: !selected_region }"
            v-model="selected_region"
            @change="search()"
          >
            <option :value=null>Toutes les régions</option>
            <option
              v-for="region in facets.regions"
              :key="region.key"
              :value="region.key"
            >
              {{ region.region_name }} ({{ region.doc_count }})
            </option>
          </select>
        </div>
      </div>
      <div class="filter-box">
        <p class="filter-box-title">Département</p>
        <div class="filter-box-content">
          <input
            class="text-field"
            type="text"
            placeholder="Département"
            v-model="selected_departement"
            list="options-departement"
          />
          <datalist id="options-departement">
            <option v-for="departement of options_departement ">{{departement}}</option>
          </datalist>
        </div>
      </div>
      <div class="filter-box">
        <p class="filter-box-title">Commune</p>
        <div class="filter-box-content">
          <input
            class="text-field"
            type="text"
            placeholder="Commune"
            v-model="selected_commune"
            list="options-commune"
          />
          <datalist id="options-commune">
            <option v-for="commune of options_commune ">{{commune}}</option>
          </datalist>
        </div>
      </div>
      <div class="filter-box">
        <p class="filter-box-title">Segments de marché</p>
        <div class="filter-box-content">
          <select
            class="select"
            :class="{ empty: !selected_segment }"
            v-model="selected_segment"
            @change="search()"
          >
            <option :value="null">Tous les segments de marché</option>
            <option
              v-for="segment in facets.segments"
              :key="segment.key"
              :value="segment.key"
            >
              {{ segment.key }} ({{ segment.doc_count }})
            </option>
          </select>
        </div>
      </div>

      <div class="filter-box">
        <p class="filter-box-title">Années</p>
        <div class="filter-box-content">
          <select
            class="select"
            :class="{ empty: !selected_year }"
            v-model="selected_year"
            @change="search()"
          >
            <option :value="null">Toutes les années</option>
            <option v-for="year in facets.years" :key="year" :value="year">{{
              year
            }}</option>
          </select>
        </div>
      </div>
      <div class="filter-box">
        <p class="filter-box-title">Nom de l'Etude</p>
        <div class="filter-box-content">
          <input
            class="text-field"
            :class="{ empty: !selected_name }"
            type="text"
            placeholder="Nom de l'étude"
            v-model="selected_name"
          />
        </div>
      </div>
      <div class="filter-box">
        <p class="filter-box-title">Plan relance</p>
        <div class="filter-box-content">
          <select
            class="select"
            :class="{ empty: !selected_relance }"
            v-model="selected_relance"
            @change="search()"
          >
            <option :value="null">-</option>
            <option :value="true">Oui</option>
            <option :value="false">Non</option>
            
          </select>
        </div>
      </div>
    </div>
    <div class="reset-filters__wrapper">
      <button
        class="reset-filters"
        @click="resetFacets"
        :disabled="!hasActiveFilters"
      >
        Réinitialiser les filtres
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const axios = require("axios");

export default {
  name: "filters",

  data: function() {
    return {
      options_commune: [],
      options_departement: [],
      // show_location_filter: true,
      loc: "",
      years: {},
      types: {
        flash: false,
        agglo: false,
        grille: false,
        bdd: false
      }
    };
  },
  computed: {
    ...mapGetters(["filters", "facets", "city_map", "dpt_map"]),
    selected_year: {
      get() {
        return this.filters.year;
      },
      set(newValue) {
        return this.$store.dispatch("set_filter", { year: newValue });
      }
    },
    selected_region: {
      get() {
        return this.filters.region;
      },
      set(newValue) {
        return this.$store.dispatch("set_filter", { region: newValue });
      }
    },
    selected_departement: {
      get() {
        return this.filters.departement;
      },
      set(newValue) {
        this.$store.dispatch("set_filter", { departement: newValue });
        this.search();
      }
    },
    selected_commune: {
      get() {
        return this.filters.commune;
      },
      set(newValue) {
        this.$store.dispatch("set_filter", { commune: newValue });
        this.search();
      }
    },
    selected_name: {
      get() {
        return this.filters.name;
      },
      set(newValue) {
        this.$store.dispatch("set_filter", { name: newValue });
        this.search();
      }
    },
    selected_document_type: {
      get() {
        return this.filters.document_type;
      },
      set(newValue) {
        return this.$store.dispatch("set_filter", { document_type: newValue });
      }
    },
    selected_segment: {
      get() {
        return this.filters.segment;
      },
      set(newValue) {
        return this.$store.dispatch("set_filter", { segment: newValue });
      }
    },
    selected_relance: {
      get() {
        return this.filters.relance;
      },
      set(newValue) {
        return this.$store.dispatch("set_filter", { relance: newValue });
      }
    },
    hasActiveFilters() {
      return (
        this.filters.commune !== null||
        this.filters.departement !== null ||
        this.filters.document_type !== null ||
        this.filters.location !== null ||
        this.filters.name !== null ||
        this.filters.region !== null ||
        this.filters.relance !== null ||
        this.filters.segment !== null ||
        this.filters.year !== null
      );
    }
  },
  methods: {
    search: function() {
      this.$store.dispatch("load_projects_v2");
      //console.log(this.selected_study_name)
      this.$store.dispatch("set_last_action");
    },
    resetFacets() {
      this.$store.dispatch("set_filter", {
        commune: null,
        departement: null,
        document_type: null,
        location: null,
        name: null,
        region: null,
        relance:null,
        segment: null,
        year: null,
      });
      this.search();
    },
    triggerGtm(label = "", value = "") {
      if(value != null) {
        this.$gtm.trackEvent({
          category: 'Search',
          action: 'Update filters',
          label,
          value
        });
      }
    }
  },
  mounted: function() {},
  watch: {
    selected_commune: async function(newValue) {
      if(newValue !== null && newValue.length > 1){
        this.options_commune = await this.$store.dispatch("get_autocompletion_commune", { commune: newValue });
      }else{
        this.options_commune = [];
      }
    },
    selected_departement: async function(newValue) {
      if(newValue !== null && newValue.length > 0){
        this.options_departement = await this.$store.dispatch("get_autocompletion_departement", { departement: newValue });
      }else{
        this.options_departement = [];
      }
    },
    selected_region(value) {
      this.triggerGtm("region", value);
    },
    selected_segment(value) {
      this.triggerGtm("segment", value);
    },
    selected_year(value) {
      this.triggerGtm("année", value);
    },
    selected_name(value) {
      this.triggerGtm("Nom de l'étude", value);
    },
     selected_relance(value) {
      this.triggerGtm("Plan Relance", value);
    },
  }
};
</script>

<style lang="stylus">
@import '../../assets/css/app';

.filters
	padding 0 20px 0 120px

.filters-wrapper
	display flex
	.search-box
		position fixed
		top 132px
		left 48px
		width 350px


	.filter-box
		flex 0 1 260px
		text-align left
		margin 0 24px 0 0
		.filter-box-title
			height 16px
			line-height 16px
			transform translateY(-2px)
			color #fff
			text-transform uppercase
			font-weight 500
		.filter-box-content
			display block
			height (56px - 16px)
			.IZ-select
				&.small
					.IZ-select__input
						width 140px
				.IZ-select__input
					height 40px
					max-width 260px
					width 100%
					border none
					border-radius radius
					appearance none
					input
						font-size 1.3rem
						padding 0 14px
				.IZ-select__menu
					.IZ-select__item
						white-space nowrap
						&.IZ-select__item--selected
							background-color red !important
							color #fff !important
						strong
							font-weight 500
			.select,
			.text-field
				display block
				height 40px
				max-width 260px
				width 100%
				padding 0 12px
				background #fff
				appearance none
				border none
				border-radius radius
				font inherit
				cursor pointer
				&.empty
					color #999
					font-weight 400
				option
					color #333
			.text-field
				cursor text

.reset-filters
	background none
	border none
	color: #fff
	text-decoration underline
	cursor pointer

	&:disabled
		opacity 0.3
		cursor default

	&:not(:disabled)
		&:hover
			opacity 0.7

	&__wrapper
		text-align left
		padding-top 5px
</style>
